module.exports = "../../static/img/close_img.b17b3f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/close_img.png
// module id = 1282
// module chunks = 4